<template>
  <div>
    <el-card class="box-card" style="margin-top: 20px">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="addAdertising"
            icon="el-icon-plus"
            >添加</el-button
          >
          <!-- <el-button :size="buttonSize" type="primary" @click="pageList"
            >查询</el-button
          > -->
        </el-col>
      </el-row>
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column v-if="isHzAgent" prop="type" label="广告软件" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type == '1'">68小程序</span>
            <span v-if="scope.row.type == '2'">弘智课堂app</span>
            <span v-if="scope.row.type == '3'">弘智课堂小程序</span>
            <span v-if="scope.row.type == '4'">弘智助手</span>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="首页弹框" align="center">
          <template slot-scope="scope">
            <div>
              <img
                v-if="scope.row.url"
                :src="scope.row.url"
                alt=""
                style="width: 80px; height: 80px"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="details" label="广告内容" align="center">
          <template slot-scope="scope">
            <div>
              <img
                v-if="scope.row.details"
                :src="scope.row.details"
                alt=""
                style="width: 80px; height: 80px"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="enable" label="是否应用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enable"
              :active-value="1"
              :inactive-value="0"
              @change="application(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="180" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span @click="editVersion(scope.row)">编辑</span>
              <span @click="deleteApp(scope.row.id)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!tableLoading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      destroy-on-close
      left
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-form-item label="弹框广告" prop="url">
          <el-upload
            class="avatar-uploader"
            :action="fileAction"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="addForm.url"
              :src="addForm.url"
              class="avatar"
              style="width: 80px; height: 80px"
            />
            <i v-else class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="广告内容" prop="details">
          <el-upload
            class="avatar-uploader"
            :action="fileAction"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="addForm.details"
              :src="addForm.details"
              class="avatar"
              style="width: 80px; height: 80px"
            />
            <i v-else class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="isHzAgent" label="广告软件" prop="type">
          <el-select
            size="medium"
            collapse-tags
            v-model="addForm.type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in replyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="buttonSize" type="primary" @click="editTheNew"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      replyList: [{
        id: 1,
        name: '68小程序'
      }, {
        id: 2,
        name: '弘智课堂app'
      }, {
        id: 3,
        name: '弘智课堂小程序'
      }, {
        id: 4,
        name: '弘智助手'
      }],
      isHzAgent: false,
      tableLoading: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        pageNumber: "",
        pageSize: ""
      },
      styles: {
        width: "300px"
      },
      selectParams: {
        clearable: true,
        placeholder: "请选择资源"
      },
      addForm: {
        url: '',
        details: '',
        type: '',
        enable: ''
      },
      addFormRules: {
        url: [
          {
            required: true,
            message: "请选择图片",
            trigger: "blur"
          }
        ],
        details: [
          {
            required: true,
            message: "请选择图片",
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择",
            trigger: "blur"
          }
        ],
      },
      editForm: {
        name: "",
        version: 1
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      fileList: [],
      loading: false,
      buttonSize: document.body.clientWidth < 992 ? "mini" : ""
    };
  },
  methods: {
    handleAvatarSuccess1 (res, file) {
      console.log(res, file)
      this.addForm.details = file.response.data;
    },
    handleAvatarSuccess (res, file) {
      console.log(res, file)
      this.addForm.url = file.response.data;
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    addAdertising () {
      this.addFormVisible = true;
      this.addForm = {
        url: '',
        details: '',
        type: ''
      }
    },
    // 列表
    pageList () {
      this.tableLoading = true
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.advertising
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          console.log(this.page.rows, 6666);
          this.page.total = result.data.total;
          this.tableLoading = false
        })
        .catch(error => {
          this.tableLoading = false
        });
    },
    editTheNew () {
      if (this.addForm.id) {
        this.updateApp()
        console.log('binaji');
      } else {
        this.addApp()
        console.log('xinzeng');
      }
    },
    addApp () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.advertising
            .addAdvertisement(this.addForm)
            .then(result => {
              if (result.code == 200) {
                this.pageList();
                this.addFormVisible = false;
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.$refs.searchForm.resetFields();

              } else {
                this.$message.error(result.message)
              }

            }).catch(error => {
            });
        } else {
          return false;
        }
      });
    },
    editVersion (row) {
      console.log(row, 78798)
      this.addForm = {
        url: '',
        details: '',
        type: ''
      }
      this.addForm = row
      this.addForm.type = row.type
      this.addFormVisible = true;
    },
    updateApp () {
      console.log(this.addForm)
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.advertising
            .deleteAdvertisement(this.addForm)
            .then(result => {
              if (result.code == 200) {
                this.pageList();
                this.addFormVisible = false;
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.$refs.searchForm.resetFields();
              } else {
                this.$message.error(result.message)
              }


            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteApp (id) {
      console.log(id);
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.advertising
            .deleteAdvertisement(
              {
                id: id,
                state: -1
              }
            )
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
        })
    },
    application (row) {
      var from = {
        id: '',
        enable: '',
        type: ''
      }
      from.id = row.id
      from.type = row.type
      from.enable = row.enable
      this.api.advertising
        .updateAdvertisement(from)
        .then(result => {
          if (result.code == 200) {
            this.pageList();
            this.addFormVisible = false;
            this.$message({
              type: "success",
              message: result.message
            });
            this.$refs.searchForm.resetFields();
          } else {
            this.$message.error(result.message)
            this.pageList();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  computed: {
    upLoadData () {
      return {
        openId: this.$store.state.loginData.openId,
        token: this.$store.state.loginData.token,
        LoginType: "agent",
      };
    }
  },
  mounted () {
    if(localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).agentId == '621995219419136') {
      this.isHzAgent = true;
    }
    this.pageList();

  }
};
</script>
<style lang="less" rel="stylesheet/less">
.avatar-uploader {
  display: flex;
  flex-wrap: wrap;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 80px;
  height: 80px;
  line-height: 80px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
.el-upload-list--picture-card {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/advertising/index.vue